import { NavLink, Route } from 'react-router-dom';
import styled from 'styled-components';

import Tab from './Tab';

interface NavTabProps {
  icon?: React.ReactNode;
  to?: string;
  title?: string;
  activeOnlyWhenExact?: boolean;
}

const NavTab: React.FC<NavTabProps> = ({ icon, to, activeOnlyWhenExact, title }) => {
  return (
    <StyledNavTab>
      <Route
        children={({ match }) => (
          <NavLink to={{ pathname: to }}>
            <Tab className="tab" selected={!!match}>
              <div className="icon">{icon}</div>
              {title}
            </Tab>
          </NavLink>
        )}
        exact={activeOnlyWhenExact}
        path={to}
      />
    </StyledNavTab>
  );
};

const StyledNavTab = styled.div`
  flex: 1;
  text-decoration: none;
  max-width: 100px;

  & .icon svg {
    margin: 8px 0 0;
    max-width: 35px;
    max-height: 35px;
  }

  @media (min-width: ${(props) => props.theme.phone}) {
    & .icon {
      display: none;
    }
  }
`;

export default NavTab;
